import Column from 'Shared/components/PagedView/Column';
import {
  withDateFilterProperties,
  withSelectFilterProperties,
  withStringFilterProperties,
} from 'Shared/components/PagedView/Filter';
import PagedView from 'Shared/components/PagedView/PagedView';
import {toFormattedDateAsUTC} from 'Shared/utilities/DateFormatter';
import {withValueChangedHook} from 'Shared/utilities/withValueChanged';
import {toUndefined} from 'fp-ts/lib/Option';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {
  DocumentStatus,
  changeDocumentFilter,
  changeSort,
  clearSort,
  fetchDocuments,
} from '../ducks/documentUploadHistory';
import {NoOp} from 'Shared/utilities/IOUtilities';
import { useBreadcrumbs } from 'Core/hooks/useBreadcrumbs';
import { useRouteMatch } from 'react-router-dom';

const DocumentUploadHistoryView = () => {
  const {documents, sort, filter, pageOption} = useSelector((state: ReducerState) => state.documentUpload);

  const [filterHolder, setFilterHolder] = useState(filter);
  const dispatch = useDispatch();
  const match = useRouteMatch();

  useEffect(() => {
    if (JSON.stringify(filter) !== JSON.stringify(filterHolder) || sort) {
      dispatch(fetchDocuments(toUndefined(pageOption), filter, toUndefined(sort)));
    }
    setFilterHolder(filter);
  }, [filter, sort, pageOption]);

  const changeFilter = withValueChangedHook(filter, changeDocumentFilter, dispatch);
  const filterProperties = {
    changeFilter,
    filterData: filter,
  };

  useEffect(() => {
    return () => {
      dispatch(clearSort());
    };
  }, [dispatch]);

  useBreadcrumbs('Document Upload History', match.url);

  return (
    <PagedView
      pagedViewKey="documents"
      eventAction="DocumentUploadHistory"
      sort={toUndefined(sort)}
      onChangeSort={newSort => dispatch(changeSort(newSort))}
      data={documents}
      loadMore={NoOp}
    >
      {columnProps => (
        <>
          <Column
            {...columnProps}
            title="Policy Number"
            sortColumnKey="policyNumber"
            filterProperties={withStringFilterProperties(filterProperties, 'policyNumber')}
            default
          >
            {doc => doc.policyNumber}
          </Column>
          <Column
            {...columnProps}
            title="Account Number"
            sortColumnKey="accountNumber"
            filterProperties={withStringFilterProperties(filterProperties, 'accountNumber')}
            default
          >
            {doc => doc.accountNumber}
          </Column>
          <Column
            {...columnProps}
            title="Filename"
            sortColumnKey="fileName"
            filterProperties={withStringFilterProperties(filterProperties, 'fileName')}
            default
          >
            {doc => doc.fileName}
          </Column>
          <Column
            {...columnProps}
            title="Date Uploaded"
            sortColumnKey="dateOfUpload"
            filterProperties={withDateFilterProperties(filterProperties, 'dateOfUpload')}
            default
          >
            {doc => toFormattedDateAsUTC(doc.dateOfUpload)}
          </Column>
          <Column
            {...columnProps}
            title="Status"
            sortColumnKey="uploadStatus"
            filterProperties={withSelectFilterProperties(filterProperties, 'uploadStatus', DocumentStatus)}
            default
          >
            {doc => doc.uploadStatus}
          </Column>
        </>
      )}
    </PagedView>
  );
};

export default DocumentUploadHistoryView;
